var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 55,
    viewBox: "0 0 59 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5031 28.9541L46.8965 17.4382C53.2134 30.273 47.8501 46.0306 35.0189 52.3476C22.1841 58.6645 6.42653 53.3011 0.109605 40.47C0.0730703 40.3969 0.0365351 40.3202 0 40.2471L23.5031 28.9541Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5329 21.0296C26.3401 21.0296 31.0477 16.322 31.0477 10.5148C31.0477 4.70764 26.3401 0 20.5329 0C14.7257 0 10.0181 4.70764 10.0181 10.5148C10.0181 16.322 14.7257 21.0296 20.5329 21.0296Z",
    fill: "#F36D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/icon7.5ff7ebc2d6be5043de7d6a3fe172c697.svg";
export { ForwardRef as ReactComponent };